import Client from "./Client";
// import RequestList from "./RequestList";

const SubscriptionService = {
    url: 'admin/subscriptions',
    getDefault(){
        return {
            id : undefined,
            subscription_class : undefined,
            user_id : undefined,
            receipt_id : undefined,
            limitation_send : undefined,
            sent_count : undefined,
            expired_at : undefined,
            created_at : undefined
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async create(subscription) {
        return await Client.post(`${this.url}`, subscription);
    },
    /**
     * @params int subscriptionId
     * @return Request Promise
     **/
     async updateFaxCount(subscriptionId) {
        return await Client.post(`${this.url}/${subscriptionId}/update-fax-count`);
    },
    /**
     * @params time_dimension
     * @params [] filters
     * @return Request Promise
     **/
     async getOverviewReport(time_dimension, filters) {
        return await Client.get(`${this.url}/reports/overview`, {
            time_dimension,
            filters
        });
    }
}

export default SubscriptionService